import { Avatar, type AvatarProps } from "@msuite/ui/avatar";
import { useQuery } from "@msuite/ui/query";
import { Tooltip } from "@msuite/ui/tooltip";
import type { ClassNameProps } from "@msuite/ui/types";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/** Props Interface */
interface OrganizationAvatarProps extends Pick<AvatarProps, "size">, ClassNameProps {
	orgId: string;
	withTooltip?: boolean;
}

export function OrganizationAvatar({
	orgId,
	size = "xs",
	className,
	withTooltip = false,
}: OrganizationAvatarProps) {
	/** Hooks */

	/** Query */
	const { data } = useQuery({
		queryKey: [orgId],
		queryFn: async () => {
			const response = await client.organizations[":orgId"].$get({
				param: { orgId },
			});
			const data = await responseHandler(response);
			return {
				organization: data.organization,
				partnership: data.partnership,
			};
		},
	});

	/** Render */
	return (
		<Tooltip
			isDisabled={!withTooltip}
			label={data?.organization?.name}
		>
			<Avatar
				size={size}
				imageUrl={data?.organization?.imageUrl ?? ""}
				className={className}
				variant="image"
			/>
		</Tooltip>
	);
}
